<template>

    <transition
            name="fade"
            mode="in-out">

        <!-- ORIENTATION WARNING -->
        <div class="orientation-warning-mobile" v-if="(!isPortrait && !is404)" :style="{ backgroundColor: cssPropColor('$color-primary') }">
            <div class="inner">

                <div class="content">
                    <h1 v-html="content.heading"></h1>
                    <div class="intro" v-html="content.text"></div>
                </div>

            </div>
        </div>
        <!-- END ORIENTATION WARNING -->

    </transition>

</template>


<script>

    import Branding from "./Branding.vue";

    let vm = {};

    export default {

        name: 'orientation-warning-mobile',

        components: {
            Branding
        },

        data() {
            return {
                isPortrait: true,
                is404:      false,
                content: {
                    heading: 'Turn Your Phone',
                    text: 'In order to interact with the Homeowners Equipment Breakdown experience, please turn your phone to the vertical position.'
                }
            }
        },

        created() {
            vm = this;
        },

        computed: {

            loaded() {
                return this.$dataStore.getters.getLoadedState;
            },

            company() {
                return this.$dataStore.getters.getCompany;
            },

            has404() {
                vm.is404 = this.$dataStore.getters.get404Status;
                return vm.is404;
            }

        },

        mounted() {
            window.addEventListener("orientationchange", vm.isMobilePortrait, false);
            vm.isMobilePortrait();
        },

        beforeDestroy() {
            window.removeEventListener("orientationchange", vm.isMobilePortrait, false);
        },

        methods: {

            /**
             * @method isMobilePortrait
             * @description
             */
            isMobilePortrait() {
                setTimeout(function() {
                    vm.isPortrait = (window.innerHeight > window.innerWidth);

                    if (vm.isPortrait) {
                        console.log('We are in portrait orientation.');
                    } else {
                        console.log('We are in landscape orientation.');
                    }

                }, 250);
            },

            /**
             * @method cssPropColor
             * @description
             * @param {String} colorProp
             * @return {boolean}
             */
            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .orientation-warning-mobile {
        background-color: var(--color-primary);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
        animation-duration: 0.3s;
        animation-delay: 0.3s;
        transition: all 0.3s $easeInOutQuad;

        &::after {
            content: '';
            background-image: url(/static/images/bg-orientation-mobile@1x.png);
            background-repeat: no-repeat;
            background-position: 50% 50%;
            background-size: contain;
            width: 80%;
            height: 80%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            z-index: -1;

            @media only screen and (min-device-pixel-ratio: 1.25),
            only screen and (min-resolution: 1.25dppx) { // @2x
                background-image: url(/static/images/bg-orientation-mobile@2x.png);
            }

            @media only screen and (min-device-pixel-ratio: 2.25),
            only screen and (min-resolution: 2.25dppx) { // @3x
                background-image: url(/static/images/bg-orientation-mobile@3x.png);
            }
        }

        & > .inner {
            height: 100%;
            padding: 20px;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            transition: all 0.3s $easeInOutQuad;
        }

        & .mast {
            background-color: $white-100;
            width: 100%;
            height: 105px;
            box-shadow: 0 2px 4px $black-25;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
        }

        & .content {
            width: 100%;
            max-width: 640px;
            flex: 0 0 auto;
            align-self: center;
            position: relative;
            z-index: 5;

            & h1 {
                font-family: $font-univers-light-cn;
                font-size: 2.188rem;
                line-height: 1;
                letter-spacing: 0.64px;
                color: $white-100;
                text-transform: uppercase;
                margin: 0 0 20px 0;
            }

            & .intro {
                font-family: $font-univers-light;
                font-size: 0.938rem;
                line-height: 1.375;
                letter-spacing: 0.58px;
                color: $white-100;
                margin: 0 0 30px 0;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// OrientationWarningMobile.vue?2b9c2a26